import {
  Activity, Bell, CalendarClock, Cable, FileChartColumn, Gauge, Globe, Network, RadioTower, ScrollText, Settings, Siren, Waypoints,
  type LucideIcon,
} from "lucide-react";

import type { Role } from "@/api/generated";

export type NavItem = { to: string; label: string; icon: LucideIcon; roles: Role[]; exact?: boolean };

const INTERNAL: Role[] = ["ADMIN", "NOC"];
const EVERYONE: Role[] = ["ADMIN", "NOC", "CUSTOMER"];

// Left rail (PRD §6.1). Customers get their own short list
// (docs/adr/2026-09-28-customer-tenancy.md).
export const NAV: NavItem[] = [
  { to: "/", label: "Ops view", icon: Activity, exact: true, roles: INTERNAL },
  { to: "/", label: "Overview", icon: Activity, exact: true, roles: ["CUSTOMER"] },
  { to: "/incidents", label: "Incidents", icon: Siren, roles: INTERNAL },
  { to: "/topology", label: "Topology", icon: Network, roles: INTERNAL },
  { to: "/network", label: "Network map", icon: Globe, roles: ["CUSTOMER"] },
  { to: "/links", label: "Links", icon: Cable, roles: ["CUSTOMER"] },
  { to: "/monitors", label: "Monitors", icon: Gauge, roles: EVERYONE },
  { to: "/reports", label: "SLA reports", icon: FileChartColumn, roles: EVERYONE },
  { to: "/probes", label: "Probes", icon: RadioTower, roles: INTERNAL },
  { to: "/bgp", label: "BGP", icon: Waypoints, roles: INTERNAL },
  { to: "/maintenance", label: "Maintenance", icon: CalendarClock, roles: INTERNAL },
  { to: "/notifications", label: "Notifications", icon: Bell, roles: ["ADMIN"] },
  { to: "/settings", label: "Settings & access", icon: Settings, roles: ["ADMIN"] },
  { to: "/audit", label: "Audit log", icon: ScrollText, roles: ["ADMIN"] },
];
